import React, { useEffect, useRef, useState } from "react";
import QRCodeStyling from "qr-code-styling";
import { useSearchParams } from "react-router-dom";
import { get_event_title } from "../../Api/data";
import Arrow from "../../assets/SettingsPage/SVG/Arrow 1.svg";

const qrCode = new QRCodeStyling({
  width: 200,
  height: 200,
  dotsOptions: {
    color: "#161B41",
    // type: "dots"
  },
  // cornersDotOptions: {
  //     type: "circle"
  // },
  // cornersSquareOptions: {
  //     type: "extra-rounded"
  // },
  imageOptions: {
    crossOrigin: "anonymous",
    imageSize: 0.1,
    // margin: 20
  },
  // shape: 'circle'
});

function QRCodeScreen(props) {
  const [url, setUrl] = useState(`${props.uid}`);
  let [searchParams, setSearchParams] = useSearchParams();
  const [fileExt, setFileExt] = useState("png");
  const ref = useRef(null);
  const paramIDS = searchParams.get("u");
  const [uid, setUID] = useState("");
  const [id, setID] = useState();
  const [title, setTitle] = useState("Loading...");

  const getData = async (UID, ID) => {
    const title = await get_event_title(UID, ID);
    setTitle(title);
  };

  useEffect(() => {
    qrCode.append(ref.current);
    if (paramIDS) {
      const [uid, id] = paramIDS.split("--i=");
      setUID(uid);
      setID(id);
      getData(uid, id);
    }
  }, []);

  useEffect(() => {
    qrCode.update({
      data: uid + "/" + id,
    });
  }, [uid, id]);

  return (
    <div style={{ flexDirection: "column", ...styles.container }}>
      <div className="flex bg-[#141414] mb-10 w-full my-6 px-2 justify-between">
        <div
        
          onClick={() => window.history.go(-1)}
        >
          <img src={Arrow} />
        </div>
        <h3 className="font-semibold w-full self-center">QR Code</h3>
      </div>

      <div style={styles.container}>
        <div className="bg-[white] overflow-hidden mb-[25px] p-[45px] rounded-full">
          <div
            ref={ref}
            style={{
              borderRadius: 150,
            }}/>
        </div>
        <div className="bg-[white] w-[80%] mt-10  rounded shadow-sm">
          <h1 className="text-[#161B41] font-medium ">{title}</h1>
        </div>
      </div>
    </div>
  );
}

const styles = {
  inputWrapper: {
    margin: "20px 0",
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  inputBox: {
    flexGrow: 1,
    marginRight: 20,
  },
  container: {
    borderRadius: 150,
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
  },
};

export default QRCodeScreen;
